var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-extend-layouts'),(_vm.credential)?_c('EasterEggsWelcomeModal'):_vm._e(),(_vm.credential)?_c('EasterEggsEndRoundModal'):_vm._e(),_c('Notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }